module.exports = __webpack_public_path__ + "static/media/ProximaNova-Sbold.321dcd51.woff";